<div class="contact-card" data-testid="contact-card">
  <div class="contact-card__header">
    <img
      height="57"
      width="57"
      class="contact-card__header__image"
      [ngSrc]="imageSource"
      [alt]="fullName" />
    <div class="contact-card__header__info">
      <p class="contact-card__header__info__type">
        {{ type | translate }}
      </p>
      <p class="contact-card__header__info__full-name" [title]="fullName">
        {{ fullName }}
      </p>
    </div>
  </div>
  <div class="contact-card__actions">
    <button
      data-testid="btn-contact-card-message"
      type="button"
      class="contact-card__button"
      [attr.aria-label]="
        ('ContactCardComponent.Contact' | translate) + ' ' + fullName
      "
      (click)="onContactClick()">
      <icon-display
        class="contact-card__button__icon"
        iconName="message"
        [width]="24"
        [height]="24" />
      <span class="contact-card__button__text">
        {{ "ContactCardComponent.Contact" | translate }}
      </span>
    </button>
    @if (hasAnnotations) {
      <button
        data-testid="btn-contact-card-annotations"
        type="button"
        class="contact-card__annotations-button"
        [attr.aria-label]="
          ('ContactCardComponent.Annotations' | translate) + ' ' + fullName
        "
        (click)="onAnnotationsClick()">
        <icon-display
          class="contact-card__annotations-button__icon"
          iconName="annotation"
          [width]="24"
          [height]="24" />
        <div class="contact-card__annotations-button__red-dot"></div>
        <span class="contact-card__annotations-button__text">
          {{ "ContactCardComponent.Annotations" | translate }}
        </span>
      </button>
    }
  </div>
</div>
